import React from "react";
import Section from "./Section";

export default function HTML_Home() {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">🏠 HTML Home — Introduction to HTML</h1>

      {/* Intro */}
      <div
        className="Key_point_container"
        style={{ backgroundColor: "#fef9c3" }}
      >
        <p>
          HTML (<b>HyperText Markup Language</b>) is the standard language used
          to build web pages. It defines the <b>structure</b> and content of a
          page using elements like text, images, and links.
        </p>
        <p>
          Every web page you’ve ever seen — from Google to YouTube — is built
          using HTML at its core.
        </p>
      </div>

      {/* Section 1 */}
      <Section
        title="1️⃣ What is HTML?"
        html={`<h1>Welcome to HTML!</h1>
<p>HTML stands for <b>HyperText Markup Language</b>.</p>
<p>It is the language used to create web pages.</p>`}
        description="HTML stands for HyperText Markup Language and is used to structure the content of web pages."
      />

      {/* Section 2 */}
      <Section
        title="2️⃣ Basic HTML Example"
        html={`<!DOCTYPE html>
<html>
  <head>
    <title>My First HTML Page</title>
  </head>
  <body>
    <h1>Hello, World!</h1>
    <p>This is my first web page using HTML.</p>
  </body>
</html>`}
        description="Every HTML document starts with <!DOCTYPE html> and contains <html>, <head>, and <body> tags."
      />

      {/* Section 3 */}
      <Section
        title="3️⃣ HTML Structure"
        html={`<!DOCTYPE html>
<html>
  <head>
    <title>Page Title</title>
  </head>
  <body>
    <h1>Heading</h1>
    <p>Paragraph text.</p>
  </body>
</html>`}
        description="The <head> contains metadata and the title, while the <body> holds the visible page content."
      />

      {/* Section 4 */}
      <Section
        title="4️⃣ Links and Images"
        html={`<h2>My Favorite Website</h2>
<a href="https://www.wikipedia.org" target="_blank">Visit Wikipedia</a>
<br/><br/>
<img src="https://via.placeholder.com/150" alt="Sample Image" />`}
        description="Use <a> for links and <img> for images. The href attribute defines the link destination."
      />

      {/* Section 5 */}
      <Section
        title="5️⃣ Lists Example"
        html={`<h3>My Favorite Fruits</h3>
<ul>
  <li>Apple</li>
  <li>Mango</li>
  <li>Banana</li>
</ul>

<h3>Steps to Learn HTML</h3>
<ol>
  <li>Understand basic tags</li>
  <li>Learn structure</li>
  <li>Build a web page</li>
</ol>`}
        description="HTML supports ordered (<ol>) and unordered (<ul>) lists for organizing content."
      />

      {/* Summary */}
      <div
        style={{
          background: "linear-gradient(135deg, #d1fae5, #a7f3d0)",
          padding: "1rem",
          borderRadius: "12px",
          marginTop: "2rem",
        }}
      >
        <h2 style={{ color: "#065f46" }}>📘 Summary</h2>
        <ul className="tutorial-list-points">
          <li>HTML defines the structure of every webpage.</li>
          <li>
            Always start your file with <b>&lt;!DOCTYPE html&gt;</b>.
          </li>
          <li>
            Use <b>&lt;head&gt;</b> for metadata and <b>&lt;body&gt;</b> for
            content.
          </li>
          <li>
            Add links with <b>&lt;a href&gt;</b> and images with{" "}
            <b>&lt;img src&gt;</b>.
          </li>
          <li>
            Combine HTML with CSS and JavaScript for full web development.
          </li>
        </ul>
      </div>
    </div>
  );
}
